import { Category } from '../types';
import { BarChart3, MessageSquare, Computer, ClipboardList, Building } from 'lucide-react';

export const categories: Category[] = [
  {
    id: 'financial',
    title: 'Financial Management',
    description: 'Evaluate your church\'s financial processes and controls',
    icon: 'BarChart3'
  },
  {
    id: 'communications',
    title: 'Communications & Media',
    description: 'Assess your church\'s communication effectiveness and media presence',
    icon: 'MessageSquare'
  },
  {
    id: 'administrative',
    title: 'Technology & Data Management',
    description: 'Review your digital infrastructure and data handling practices',
    icon: 'ClipboardList'
  },
  {
    id: 'technology',
    title: 'Administrative Systems',
    description: 'Evaluate your administrative processes and workflow efficiency',
    icon: 'Computer'
  },
  {
    id: 'facilities',
    title: 'People',
    description: 'Evaluate your leadership development and staff/volunteer management',
    icon: 'Building'
  }
];